/**
 * @spec docs/specs/features/staking-position-ui.md#phase-2-authentication
 * Sign-in button for social authentication
 */
import { usePrivy } from '@privy-io/react-auth';
import { Button, type ButtonProps } from '@/components/ui/Button';
import { cn } from '@/lib/cn';

export interface SignInButtonProps extends Omit<ButtonProps, 'onClick'> {
  /** Custom button text */
  children?: React.ReactNode;
}

/**
 * Sign-in button that opens Privy's authentication modal
 *
 * Supports social auth methods: email, Google, passkey
 * Also allows wallet connection from the same modal
 */
export function SignInButton({
  size = 'md',
  variant = 'outline',
  className,
  children,
  ...props
}: SignInButtonProps) {
  const { login, ready, authenticated } = usePrivy();

  // Don't show if already authenticated
  if (authenticated) return null;

  return (
    <Button
      variant={variant}
      size={size}
      onClick={login}
      disabled={!ready}
      isLoading={!ready}
      className={cn(className)}
      {...props}
    >
      {children ?? 'Sign In'}
    </Button>
  );
}
